import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';
import {
  IntegrationInstancesMethods
} from "../../../../integrationsMarketplace/integrationsMarketplaceGridInstalled/types";

export class IntegrationProfilesForVmware extends GzSingleSelectComplexBaseDataProvider {
  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'IntegrationInstances',
        method: IntegrationInstancesMethods.GET_AVAILABLE_INTEGRATION_INSTANCES,
        payload: {
          page: request.page,
          limit: request.limit,
          params: {
            companyId: request.context.companyId,
            integrationName: request.searchValue,
          }
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'IntegrationInstances',
        method: IntegrationInstancesMethods.GET_AVAILABLE_INTEGRATION_INSTANCES,
        payload: {
          page: 1,
          limit: DEFAULT_DATA_LIMIT,
          params: {
            companyId: request.context.companyId,
          }
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
